var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultidiet = function SvgMultidiet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69886 44.837L12.7239 43.9062L10.3969 45.4575L9.69886 44.837Z",
    fill: "#EFEFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7065_54585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4692 13.8674L29.4692 4.01668L26.832 2L18.6102 2.93078L15.973 5.56797L15.973 15.8841L18.3775 15.4962L18.3775 5.33528L18.5326 5.18015L26.6769 4.17181L26.7545 4.24937L26.7545 14.3328L29.4692 13.8674Z",
    fill: "url(#paint0_linear_7065_54585)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8413 3.55143C28.8412 3.55135 28.8411 3.55126 28.841 3.55118L26.9798 2L18.6028 2.93078L16.8188 4.71476C20.7433 4.27584 28.7571 3.49155 28.841 3.55118L28.8413 3.55143Z",
    fill: "url(#paint1_linear_7065_54585)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7065_54585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6175 11.1763L34.4328 9.65137C34.3736 9.63396 34.3115 9.6285 34.2502 9.63529L11.2289 12.1846L10.5324 41.7444C10.5313 41.7907 10.5233 41.8367 10.5087 41.8806L9.62519 44.5311C9.56347 44.7163 9.62384 44.9202 9.77638 45.042L17.977 51.5874L40.5947 45.4951C40.8307 45.4316 40.9773 45.1963 40.9304 44.9564L39.6175 38.2463L39.6175 11.1763Z",
    fill: "#FDFDFD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2901 9.53809L39.5645 11.0894L15.0541 14.1144L11.4085 12.1753L34.2901 9.53809Z",
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0441 14.0387L39.3994 11.0137L15.6647 14.5816L15.6647 43.7459L15.0441 14.0387Z",
    fill: "#C5C5C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3966 12.1733L34.3557 9.53613L34.3557 11.6304L11.3966 12.1733Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7952 40.9049C38.0696 39.4916 39.5433 29.1985 39.6208 24.2285L39.6209 39.276L32.7952 40.9049Z",
    fill: "#F2EEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.064 44.4187L39.7134 39.2266L15.7459 45.4317L15.064 44.4187Z",
    fill: "#ECECEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3233 12.1865L15.0464 14.7462L15.0464 14.0481L11.3233 12.1865Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7793 42.6678L12.7793 13.0381L12.469 42.6678L17.7434 51.4326L12.7793 42.6678Z",
    fill: "#E9E9E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9653 17.132L33.9653 7.28133L31.3281 5.26465L23.1063 6.19542L20.4691 8.83262L20.4691 19.1487L22.8736 18.7609L22.8736 8.59993L23.0287 8.4448L31.173 7.43646L31.2506 7.51402L31.2506 17.5974L33.9653 17.132Z",
    fill: "url(#paint2_linear_7065_54585)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3374 6.81608C33.3373 6.816 33.3372 6.81591 33.3371 6.81583L31.4759 5.26465L23.0989 6.19542L21.3149 7.97941C25.2394 7.54048 33.2532 6.7562 33.3371 6.81583L33.3374 6.81608Z",
    fill: "url(#paint3_linear_7065_54585)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5301 27.9972C29.4954 26.912 30.2125 26.1114 31.2144 26.0793C32.2164 26.0473 32.9707 26.8008 33.0054 27.886C33.0401 28.9713 32.3347 29.7591 31.3332 29.7912C30.3317 29.8232 29.5645 29.0701 29.5301 27.9972ZM34.3047 27.8445C34.2502 26.1425 32.9216 24.8644 31.1778 24.9202C29.4339 24.976 28.1773 26.3368 28.2318 28.0388C28.2862 29.7408 29.6144 31.0065 31.3707 30.9503C33.127 30.8941 34.3591 29.546 34.3047 27.8445Z",
    fill: "#546F65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9447 25.6037C22.91 24.5185 23.627 23.7178 24.629 23.6858C25.6309 23.6537 26.3852 24.4073 26.42 25.4925C26.4547 26.5777 25.7492 27.3656 24.7477 27.3976C23.7462 27.4297 22.979 26.6765 22.9447 25.6037ZM27.7192 25.4509C27.6648 23.7489 26.3362 22.4709 24.5919 22.5267C22.8476 22.5825 21.5914 23.9433 21.6459 25.6453C21.7003 27.3472 23.0285 28.6129 24.7848 28.5567C26.5411 28.5005 27.7732 27.1524 27.7188 25.4509",
    fill: "#546F65"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8091 22.3496C33.3568 23.3457 32.3757 24.0289 31.1454 24.0683C29.9152 24.1077 28.8814 23.4889 28.3654 22.5238L33.8096 22.3496L33.8091 22.3496Z",
    fill: "#FF5F5A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8146 29.4207C26.0407 29.3815 27.0612 30.0025 27.5781 30.9657L22.1436 31.1396C22.5987 30.1453 23.5798 29.4603 24.8146 29.4207Z",
    fill: "#FF9B00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6207 45.0072L15.0307 14.0481L15.0307 45.0072L17.5903 51.5893L15.6207 45.0072Z",
    fill: "#ECECEC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_7065_54585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.061 42.7203L14.9457 43.2434C14.4257 43.4874 13.8085 43.2315 13.6136 42.6912L12.4074 39.3481L14.6882 38.2782L16.4879 41.3429C16.7788 41.8382 16.581 42.4763 16.061 42.7203Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9333 41.6246L18.9357 40.9085C19.4031 40.5746 19.4823 39.9112 19.1067 39.4766L16.7828 36.7877L14.7329 38.2522L16.5233 41.3223C16.8127 41.8184 17.466 41.9585 17.9333 41.6246Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6693 42.1021L16.6061 42.7243C16.1103 43.0145 15.4725 42.8157 15.2293 42.2953L13.7248 39.0754L15.8991 37.803L17.9695 40.6917C18.3041 41.1585 18.165 41.812 17.6693 42.1021Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.9059 41.9084C17.8395 41.9813 17.7596 42.0485 17.6683 42.102L16.6074 42.7229C16.11 43.014 15.4721 42.8148 15.2297 42.2957L13.7256 39.0737L15.8981 37.8023L16.1957 38.2176C15.574 38.9426 15.437 39.9836 15.9272 40.8211C16.3445 41.5343 17.1094 41.9214 17.9059 41.9084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8969 35.5805C14.8461 36.7928 14.5034 37.4125 14.6946 38.7188C14.7227 38.9142 14.7626 39.0966 14.8119 39.2685L14.1022 40.0604C13.9259 40.0302 13.7403 40.0104 13.543 40.0037C12.2236 39.9562 11.645 40.3644 10.4455 40.5473C9.71102 40.6598 8.95631 40.4941 8.21137 39.7319C7.85752 39.3722 7.67001 38.9535 7.56689 38.5726C7.41074 37.9976 6.95073 37.5665 6.38445 37.3805C5.85876 37.2073 5.40364 36.8656 5.11867 36.3974C4.92667 36.0787 4.8391 35.7543 4.81076 35.4641C4.75171 34.8863 4.44466 34.3794 3.96995 34.0438C3.80637 33.9255 3.64144 33.7824 3.49475 33.6084C3.2439 33.3079 3.06988 32.9534 2.96619 32.5625C2.4536 30.623 4.15988 28.7192 6.1461 29.0144C6.54592 29.0749 6.91502 29.2118 7.24108 29.4284C7.43008 29.5552 7.59266 29.7009 7.72569 29.8532C8.11344 30.2858 8.64846 30.5384 9.23161 30.5314C9.52084 30.5305 9.8552 30.5796 10.1906 30.7383C10.6871 30.9704 11.0787 31.3829 11.3059 31.8892C11.5526 32.4318 12.0314 32.842 12.62 32.9345C13.0122 32.9928 13.4465 33.1362 13.8426 33.4487C14.6816 34.106 14.9286 34.8381 14.8969 35.5805Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4458 39.7629C14.3502 39.8189 14.2261 39.8099 14.139 39.7319L5.63334 32.1085C5.52595 32.012 5.5169 31.8469 5.61356 31.7392C5.70991 31.6319 5.87498 31.6229 5.98268 31.719L14.4886 39.3427C14.5959 39.4391 14.6049 39.6042 14.5084 39.7121C14.4896 39.7326 14.4688 39.7495 14.4458 39.7629Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83843 33.8405C7.80803 33.8583 7.77415 33.8702 7.73759 33.8744L6.1014 34.0695C5.9577 34.0867 5.82796 33.9843 5.81083 33.8408C5.79402 33.6969 5.8992 33.5673 6.03904 33.5505L7.67523 33.3555C7.81893 33.3382 7.94867 33.4406 7.96579 33.5841C7.97842 33.6906 7.92524 33.7897 7.83843 33.8405Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83793 33.8405C7.79827 33.8637 7.75255 33.8765 7.70335 33.8763C7.55933 33.8749 7.44298 33.7569 7.44434 33.6127L7.45928 31.9654C7.46039 31.8207 7.57806 31.7054 7.7234 31.7061C7.86742 31.7076 7.98377 31.8255 7.98241 31.9698L7.96746 33.6171C7.96655 33.7126 7.91459 33.7956 7.83793 33.8405Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0153 35.7921C9.98493 35.8099 9.95105 35.8218 9.91405 35.8263L8.2783 36.0211C8.13504 36.0381 8.00518 35.9354 7.98818 35.7922C7.97149 35.6484 8.07496 35.519 8.21682 35.5016L9.85257 35.3068C9.99583 35.2898 10.1257 35.3924 10.1427 35.5357C10.1553 35.6422 10.1021 35.7413 10.0153 35.7921Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0152 35.7926C9.97557 35.8158 9.92986 35.8287 9.88065 35.8285C9.73663 35.827 9.62028 35.709 9.62208 35.5645L9.63747 33.917C9.63813 33.7726 9.75637 33.6572 9.90114 33.658C10.0452 33.6595 10.1615 33.7774 10.1597 33.9219L10.1443 35.5695C10.1439 35.6647 10.0919 35.7477 10.0152 35.7926Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1934 37.7438C12.163 37.7616 12.129 37.7732 12.0924 37.7775L10.4562 37.9725C10.3125 37.9898 10.1829 37.8876 10.1659 37.7443C10.1491 37.6004 10.2536 37.4706 10.3941 37.454L12.0303 37.259C12.174 37.2417 12.3036 37.3439 12.3206 37.4872C12.3334 37.5939 12.2802 37.693 12.1934 37.7438Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.194 37.7437C12.1544 37.7669 12.1088 37.7799 12.0596 37.7797C11.9153 37.7778 11.7991 37.6601 11.8003 37.5156L11.8154 35.8686C11.8168 35.7234 11.9344 35.609 12.0795 35.6093C12.2235 35.6108 12.3399 35.7287 12.3387 35.8732L12.3237 37.5205C12.3227 37.6157 12.2707 37.6988 12.194 37.7437Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2784 37.1136C13.3602 37.6629 14.0683 37.6677 15.1136 38.4742C15.2702 38.5945 15.4096 38.7186 15.5353 38.8457L16.5734 38.6148C16.6334 38.4463 16.707 38.2748 16.7979 38.0995C17.4026 36.9259 18.0419 36.6214 18.7888 35.6652C19.2467 35.0799 19.4718 34.3407 19.1721 33.318C19.0318 32.8333 18.7587 32.4647 18.4771 32.1883C18.0522 31.7705 17.9016 31.1583 18.0168 30.5735C18.1233 30.0303 18.0483 29.4662 17.7796 28.9884C17.5958 28.665 17.3559 28.4297 17.1168 28.2629C16.6419 27.9284 16.3504 27.4124 16.2903 26.8342C16.2673 26.6337 16.2233 26.4198 16.1434 26.2067C16.0043 25.8408 15.7804 25.5154 15.4904 25.2336C14.0505 23.8368 11.555 24.392 10.8396 26.2683C10.6965 26.6465 10.6351 27.0353 10.6642 27.4257C10.6822 27.6525 10.7296 27.8657 10.7973 28.0562C10.9846 28.6062 10.9427 29.1963 10.651 29.7014C10.5086 29.9531 10.3876 30.2686 10.3617 30.6387C10.321 31.1853 10.4888 31.7288 10.8189 32.1749C11.1712 32.6557 11.2943 33.274 11.0866 33.8325C10.9454 34.203 10.8577 34.6518 10.9361 35.1503C11.0983 36.2037 11.6156 36.7776 12.2784 37.1136Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1445 38.7692C16.1215 38.7826 16.0966 38.7925 16.0695 38.7988C15.9281 38.8301 15.7886 38.7414 15.7576 38.6004L13.2768 27.4506C13.2457 27.3096 13.3346 27.1703 13.4752 27.1387C13.6164 27.1071 13.7559 27.1959 13.7871 27.3371L16.2677 38.4865C16.293 38.6006 16.2401 38.7132 16.1445 38.7692Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2173 30.1075C14.1305 30.1583 14.018 30.1561 13.9313 30.0929C13.8147 30.0079 13.7889 29.8444 13.8738 29.7279L14.8448 28.3971C14.931 28.2816 15.0933 28.2547 15.2101 28.3401C15.3267 28.4251 15.3526 28.5886 15.2676 28.7052L14.2966 30.0359C14.2746 30.0659 14.2477 30.0897 14.2173 30.1075Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2171 30.1079C14.1405 30.1527 14.0426 30.1573 13.9594 30.1111L12.5154 29.3176C12.3885 29.2484 12.3427 29.0892 12.4119 28.9629C12.4812 28.8366 12.6407 28.7897 12.7669 28.8599L14.2108 29.6534C14.3377 29.7226 14.3836 29.8818 14.3143 30.0081C14.2904 30.0511 14.2568 30.0846 14.2171 30.1079Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8526 32.9621C14.7658 33.0129 14.6533 33.0107 14.5666 32.9476C14.4499 32.8624 14.4242 32.6991 14.5096 32.5823L15.481 31.2513C15.5648 31.1366 15.7292 31.1093 15.8459 31.1945C15.9626 31.2797 15.9884 31.443 15.9029 31.5598L14.9315 32.8908C14.9099 32.9206 14.883 32.9443 14.8526 32.9621Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.852 32.9624C14.7753 33.0073 14.6775 33.0119 14.5938 32.966L13.1503 32.1722C13.0239 32.1027 12.978 31.9435 13.0473 31.8172C13.1166 31.6912 13.2755 31.6443 13.4027 31.714L14.8462 32.5077C14.9726 32.5772 15.0184 32.7364 14.9492 32.8627C14.9253 32.9057 14.8917 32.9392 14.852 32.9624Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.488 35.8164C15.4012 35.8672 15.2887 35.865 15.2022 35.8021C15.0853 35.7167 15.0597 35.5536 15.1447 35.437L16.1157 34.1063C16.2012 33.9906 16.3642 33.9638 16.4807 34.0488C16.5976 34.1343 16.6232 34.2973 16.5382 34.4139L15.5672 35.7446C15.5452 35.7747 15.5184 35.7986 15.488 35.8164Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4878 35.8167C15.4111 35.8616 15.3133 35.8662 15.2302 35.8202L13.7862 35.0267C13.6592 34.9573 13.6134 34.7981 13.6826 34.6718C13.7521 34.5459 13.9108 34.4986 14.0376 34.5687L15.4814 35.362C15.6084 35.4314 15.6541 35.5904 15.5849 35.7167C15.5612 35.7601 15.5275 35.7935 15.4878 35.8167Z",
    fill: "#1B5E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9139 35.4289C16.495 36.5676 15.9793 37.053 15.7621 38.3552C15.7292 38.5499 15.7115 38.7357 15.7059 38.9144L14.788 39.4516C14.6295 39.3689 14.4588 39.2934 14.2729 39.2267C13.0312 38.7783 12.3555 38.9901 11.1575 38.7976C10.4238 38.6803 9.75583 38.2919 9.27947 37.3385C9.05248 36.8879 9.00189 36.4319 9.0201 36.0377C9.04714 35.4425 8.74092 34.8914 8.25857 34.5413C7.81096 34.2157 7.48204 33.7512 7.35379 33.2183C7.26836 32.8562 7.28412 32.5206 7.34582 32.2356C7.46619 31.6674 7.32874 31.0909 6.9793 30.6263C6.85968 30.4637 6.74638 30.2771 6.65989 30.0665C6.51287 29.7037 6.45554 29.313 6.47626 28.9091C6.58092 26.9058 8.7874 25.6145 10.5884 26.5026C10.9506 26.6823 11.2602 26.9255 11.5045 27.2314C11.6457 27.4099 11.7559 27.5983 11.836 27.784C12.073 28.3144 12.5053 28.7184 13.0627 28.89C13.3383 28.9775 13.6417 29.1264 13.9125 29.38C14.3143 29.7528 14.5611 30.2653 14.6228 30.8167C14.6918 31.4088 15.0223 31.9457 15.5545 32.2136C15.9101 32.389 16.2798 32.6582 16.5615 33.0768C17.1595 33.9591 17.1709 34.7317 16.9139 35.4289Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2829 39.2424C15.1582 39.3154 14.9982 39.2736 14.9253 39.1489L9.1562 29.291C9.08322 29.1663 9.12507 29.0064 9.24977 28.9334C9.37447 28.8604 9.53442 28.9023 9.6074 29.027L15.3765 38.8848C15.4494 39.0095 15.4076 39.1695 15.2829 39.2424Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8009 31.5848C10.748 31.6157 10.6838 31.6284 10.619 31.6158L9.00178 31.3014C8.86015 31.2737 8.76748 31.1365 8.79521 30.9949C8.8225 30.8535 8.95971 30.7605 9.10135 30.7882L10.7186 31.1026C10.8602 31.1303 10.9529 31.2675 10.9252 31.4091C10.9103 31.4858 10.8634 31.5482 10.8009 31.5848Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8013 31.5846C10.7388 31.6212 10.6614 31.6316 10.5873 31.6069C10.4502 31.5618 10.376 31.4138 10.4212 31.2767L10.9392 29.7127C10.9844 29.5757 11.1327 29.5016 11.2693 29.5471C11.4064 29.5922 11.4806 29.7402 11.4354 29.8773L10.9174 31.4413C10.8967 31.5039 10.8542 31.5537 10.8013 31.5846Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2779 34.1082C12.225 34.1392 12.1609 34.1519 12.0961 34.1392L10.4788 33.8248C10.3372 33.7971 10.2445 33.66 10.2723 33.5183C10.2995 33.377 10.4368 33.2839 10.5784 33.3117L12.1957 33.626C12.3373 33.6538 12.43 33.7909 12.4022 33.9325C12.3874 34.0093 12.3405 34.0716 12.2779 34.1082Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2784 34.108C12.2158 34.1447 12.1385 34.155 12.0643 34.1304C11.9273 34.0852 11.8531 33.9372 11.8983 33.8002L12.4163 32.2362C12.4615 32.0991 12.6098 32.025 12.7464 32.0705C12.8835 32.1157 12.9576 32.2636 12.9124 32.4007L12.3944 33.9647C12.3738 34.0274 12.3313 34.0771 12.2784 34.108Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7548 36.6324C13.702 36.6634 13.6378 36.6761 13.5729 36.6632L11.9558 36.349C11.8144 36.3217 11.7216 36.1844 11.7493 36.0428C11.7766 35.9014 11.9138 35.8084 12.0555 35.8361L13.6727 36.1505C13.8141 36.1778 13.9069 36.3151 13.8792 36.4567C13.8643 36.5334 13.8174 36.5958 13.7548 36.6324Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7553 36.6322C13.6927 36.6688 13.6154 36.6792 13.5412 36.6546C13.4042 36.6094 13.3299 36.4612 13.3753 36.3246L13.8933 34.7606C13.9385 34.6235 14.0868 34.5495 14.2234 34.5949C14.3605 34.6401 14.4348 34.7883 14.3894 34.9249L13.8712 36.4887C13.8507 36.5516 13.8082 36.6013 13.7553 36.6322Z",
    fill: "#558B2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.8457 37.9379C15.8147 38.0711 15.7863 38.2089 15.7631 38.3557C15.7269 38.5525 15.7132 38.7362 15.7041 38.9172L14.7882 39.4532C14.6304 39.3699 14.459 39.2945 14.2742 39.227C13.031 38.7795 12.3535 38.9882 11.1577 38.7976C10.4238 38.6819 9.75378 38.2927 9.28089 37.3398C9.05187 36.8863 9.00304 36.4302 9.02168 36.0377C9.04792 35.4409 8.74009 34.8941 8.25528 34.5419C7.80964 34.2151 7.48386 33.7516 7.35254 33.2166C7.26772 32.8544 7.28306 32.5183 7.34626 32.233C7.46362 31.6676 7.32734 31.0931 6.98008 30.624C6.85718 30.4658 6.74628 30.2763 6.65981 30.0664C6.51407 29.7035 6.45555 29.3137 6.4734 28.9095C6.54388 27.6326 7.46744 26.6439 8.59704 26.3281C8.24844 28.3614 8.72346 30.8394 10.0701 33.1405C11.5436 35.6582 13.7233 37.3749 15.8457 37.9379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0702 38.4497L13.2264 41.2845C12.8965 41.4775 12.4725 41.3666 12.2795 41.0367L12.0749 40.6872C11.8819 40.3573 11.9928 39.9333 12.3227 39.7403L17.1665 36.9055C17.4964 36.7125 17.9203 36.8234 18.1134 37.1533L18.3179 37.5028C18.511 37.8327 18.4001 38.2567 18.0702 38.4497Z",
    fill: "#FFDC6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.8674 39.8712C14.0417 40.169 14.3193 40.3639 14.6438 40.4526L13.227 41.2817C12.8976 41.4745 12.4711 41.3667 12.2784 41.0373L12.0724 40.6854C11.8797 40.356 11.9946 39.9314 12.324 39.7386L13.7452 38.9069C13.6592 39.2359 13.6958 39.5779 13.8674 39.8712Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_7065_54585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1186 35.3007C37.3184 34.8086 36.1574 34.8238 35.0905 35.4215C34.497 35.754 34.0391 36.1459 33.7396 36.6235C33.4404 37.1006 33.2975 37.6668 33.3387 38.3517C33.3793 39.0237 33.0822 39.7154 32.55 40.2169C31.4439 41.2595 30.9975 42.7523 31.4822 44.0189C31.7045 44.5998 32.0956 45.0699 32.5931 45.4078C32.9824 45.6718 33.1679 46.1252 33.0889 46.5774C32.9844 47.1749 33.0762 47.8013 33.4092 48.3893C34.0345 49.4931 35.4541 50.184 36.9686 50.0613C37.642 50.0065 38.2516 49.8147 38.7738 49.524C39.2232 49.2739 39.832 49.2753 40.2997 49.514C41.3298 50.0399 42.7486 50.1752 44.1397 49.7004C45.882 49.1059 46.9862 47.6661 46.7403 46.2612C46.7382 46.2494 46.736 46.2387 46.7339 46.2281L46.7335 46.2272C46.5666 45.3481 46.9363 44.3995 47.8375 43.6422C48.4246 43.149 49.0399 42.5553 49.4609 41.9636C49.884 41.3689 50.1002 40.7903 49.9205 40.3206C49.6115 39.5132 48.8667 38.9502 47.9087 38.6898C46.8972 38.415 46.2634 37.7073 46.3063 36.7957C46.3307 36.2845 46.2155 35.7887 45.9401 35.3444C45.1362 34.0479 43.148 33.6788 41.2458 34.4257C40.7938 34.6032 40.3817 34.8259 40.0136 35.0804C39.3791 35.519 38.6179 35.6077 38.1186 35.3007Z",
    fill: "#FFFDF6",
    stroke: "#E7E7E7",
    strokeWidth: 0.0897698
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9277 46.893C37.8565 47.6859 35.5348 46.6495 34.742 44.5783C33.9492 42.5071 34.9855 40.1854 37.0567 39.3926C39.1279 38.5997 41.4496 39.6361 42.2424 41.7073C43.0352 43.7785 41.9989 46.1002 39.9277 46.893Z",
    fill: "#F8B600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4264 40.7187C38.5548 40.6696 38.6416 40.5414 38.6321 40.3971C38.6202 40.2204 38.4671 40.0864 38.29 40.0981C37.9878 40.1185 37.6893 40.1843 37.4037 40.2936C37.2378 40.3571 37.155 40.5425 37.2185 40.7084C37.282 40.8744 37.4675 40.9571 37.6334 40.8936C37.8593 40.8071 38.0947 40.7552 38.3331 40.7393C38.366 40.737 38.3973 40.7299 38.4264 40.7187Z",
    fill: "#F4C45B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1581 42.4658C41.324 42.4023 41.4068 42.2169 41.3432 42.0509C41.0209 41.2088 40.3476 40.556 39.4952 40.2594C39.3274 40.2011 39.1447 40.29 39.0862 40.4572C39.0282 40.6246 39.1166 40.8078 39.284 40.8661C39.9568 41.1005 40.4887 41.6158 40.7432 42.2806C40.8067 42.4465 40.9922 42.5293 41.1581 42.4658Z",
    fill: "#F4C45B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0072 36.3487C45.0637 36.3271 45.1143 36.2895 45.1523 36.2371C45.2563 36.0935 45.2245 35.8927 45.0804 35.7886C44.4716 35.3474 43.7872 35.1041 43.0466 35.0646C42.8692 35.0558 42.7181 35.1914 42.7089 35.3686C42.6996 35.5456 42.8357 35.6971 43.0129 35.7063C43.628 35.7388 44.1972 35.9416 44.7041 36.309C44.7949 36.3753 44.9094 36.3862 45.0072 36.3487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.135 36.113C41.1488 36.1077 41.1623 36.1016 41.1756 36.0941C41.1817 36.0911 41.4385 35.9525 41.8395 35.8416C42.0126 35.7933 42.1111 35.6176 42.064 35.4468C42.017 35.2756 41.84 35.1752 41.6692 35.2223C41.1866 35.3554 40.8782 35.5248 40.8651 35.5318C40.7098 35.6178 40.6536 35.8133 40.7395 35.9686C40.818 36.1106 40.988 36.1693 41.135 36.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6361 48.1738C45.5646 47.8184 46.1214 46.8423 45.9263 45.8527C45.8921 45.6787 45.7231 45.5652 45.5492 45.5998C45.3754 45.6337 45.2617 45.8031 45.2962 45.977C45.4405 46.7098 44.9855 47.4305 44.2572 47.6216L44.2105 47.6336C44.0364 47.6766 43.9328 47.85 43.9754 48.0222C44.0179 48.1944 44.1917 48.2999 44.364 48.2574L44.415 48.2443C44.4906 48.2251 44.5644 48.2013 44.6361 48.1738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7173 45.363C45.8184 45.3242 45.8973 45.2356 45.9186 45.1215C45.9998 44.6848 46.2035 44.4108 46.2055 44.408C46.314 44.2674 46.2878 44.0658 46.147 43.9577C46.0064 43.8492 45.804 43.875 45.6968 44.0162C45.6842 44.032 45.3973 44.4102 45.2871 45.0038C45.2546 45.1786 45.3696 45.3461 45.544 45.3784C45.6044 45.3897 45.6639 45.3834 45.7173 45.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4672 46.5031C36.1704 46.2049 35.2643 45.3324 35.4432 44.5544C35.6222 43.7763 36.8184 43.3873 38.1152 43.6856C39.4119 43.9838 40.3181 44.8563 40.1391 45.6344C39.9602 46.4124 38.7639 46.8014 37.4672 46.5031Z",
    fill: "#F79B21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7065_54585",
    x: 11.1984,
    y: 2,
    width: 23.0453,
    height: 23.4327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.77446
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38723
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7065_54585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7065_54585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7065_54585",
    x: 4.82686,
    y: 6.05197,
    width: 40.8866,
    height: 51.504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.38723
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7065_54585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7065_54585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_7065_54585",
    x: 1.9739,
    y: 24.4521,
    width: 18.2705,
    height: 20.684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.900126
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.450063
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7065_54585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7065_54585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_7065_54585",
    x: 25.8419,
    y: 29.4984,
    width: 29.5879,
    height: 26.9226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.900125
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.70037
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7065_54585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7065_54585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7065_54585",
    x1: 22.7211,
    y1: 15.8841,
    x2: 22.7211,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466346,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725962,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7065_54585",
    x1: 22.2483,
    y1: 2,
    x2: 22.3259,
    y2: 3.86155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7065_54585",
    x1: 27.2172,
    y1: 19.1487,
    x2: 27.2172,
    y2: 5.26465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7065_54585",
    x1: 26.7444,
    y1: 5.26465,
    x2: 26.822,
    y2: 7.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })))));
};
export default SvgMultidiet;